<template>
	<v-card class="mt-3">
		<v-card-title>
			<h2>{{departmentName}}</h2>
		</v-card-title>
		<contract-templates-list
			:possible-tags="possibleTags"
			:contract-templates="contractTemplates"
			color="indigo"
			contract-template-type="CONTRACT_TEMPLATE"
			header="Szablony umów"/>
	</v-card>
</template>

<script>
	import ContractTemplatesList from "./ContractTemplatesList";
	import {Contract} from "../../../api/generated/Contract";
	import {Department} from "../../../api/generated/Department";
	import {PossibleTagsDict} from "../../../utils/PossibleTagsDict";

	export default {
		name: "ContractTemplatesView",

		components: {ContractTemplatesList},

		methods: {
			refresh() {
				loadTemplates(this);
				loadDepartmentName(this);
			},

		},

		watch: {
			"$route.params": function () {
				this.refresh();
			},
		},

		data() {
			return {
				contractTemplates: [],
				departmentName: "",
				possibleTags: []
			};
		},

		created() {
			this.possibleTags = PossibleTagsDict.getContractTags();
			this.refresh();
		},
	};

	function loadTemplates(ctx) {
		Contract.get(ctx, ctx.$route.params.departmentId,
			successResponse => {
				ctx.contractTemplates = [];
				successResponse.forEach(function (document) {
					addTemplateToView(ctx, document);
				});
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować szablonów umów", errorResponse);
			});
	}

	function loadDepartmentName(ctx) {
		Department.getName(ctx, ctx.$route.params.departmentId, successResponse => {
				ctx.departmentName = successResponse.name;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować nazwy departamentu", errorResponse);
			});
	}

	function addTemplateToView(ctx, document) {
		if (document.contractTemplateType === "CONTRACT_TEMPLATE") {
			ctx.contractTemplates.push(document);
		}
	}
</script>

<style scoped>
</style>
